const indonesiaWords = {
  // Navigation
  // Navbar menu
  navHome: "Beranda",
  navCommitment: "Keberlanjutan",

  navCompany: "Perusahaan",
  navAbout: "Tentang SPIL",
  navHistory: "Sejarah",
  navGroup: "Grup SPIL",
  navCareer: "Karir",
  navIntern: "Internship",

  navServices: "Layanan",
  navServicesType: "Jenis Layanan",
  navGuide: "Panduan",
  navRoute: "Rute dan Jadwal",
  navBookService: "Booking Layanan",

  navContact: "Hubungi Kami",
  navMySpil: "mySPIL.com",
  navSitemap: "Sitemap",
  navLogin: "Masuk",

  navLang: "ID",
  navID: "ID",
  navENG: "ENG",

  // Floating Button
  book_service: "Pesan Layanan Kami",

  // Button
  signUp: "Daftar",
  logout: "Keluar",

  // Footer Menu
  navSpilDex: "SPILDex",
  navNews: "Berita",
  navOutlook: "Wawasan",

  // HomePage
  homeHeroTitle: "Menggerakkan Perekonomian Nasional",
  homeAboutCaption: "About Us",
  homeAboutTitle: "SPIL Connecting Islands",
  homeAboutDesc:
    "Salam Pacific Indonesia Lines (SPIL) bergerak di bidang Container Shipping, dengan jaringan logistik lebih dari 38 pelabuhan yang tersebar di seluruh Indonesia. Didukung oleh puluhan kapal container, ratusan alat berat, dan ribuan container. Dengan fasilitas operasional yang mendukung dan personnel yang handal, kami terus berkembang dan berekspansi untuk meningkatkan servis dan kepuasan pelanggan.",
  homeAboutCTA: "Who We Are",
  homeDataTitle: "Tersebar di Seluruh Indonesia",
  homeDataPort: "Pelabuhan",
  homeDataRoute: "Rute",
  homeDataSentContainer: "Kontainer Terkirim",
  homeDataServing: "Tetap Melayani",
  homeServiceCaption: "Our Services",
  homeServiceTitle: "One Stop Logistics Solutions",
  homeServiceSubtitle: "Beragam layanan untuk seluruh kebutuhan anda",
  homeServiceCTA: "Solution we offer",
  homeServicePTP: "Port to Port",
  homeServicePTPDesc:
    "Pengiriman barang dari satu pelabuhan (port) ke pelabuhan lainnya",
  homeServiceDTD: "Door to Door",
  homeServiceDTDDesc:
    "Pengiriman barang dari pintu awal penjual (tempat penyimpanan) hingga pintu tujuan pembeli.",
  homeServiceAirfreight: "Air Freight",
  homeServiceAirfreightDesc:
    "Transportasi barang Anda dengan aman dan cepat melalui pesawat terbang.",
  homeServiceLandTransport: "Land Transport",
  homeServiceLandTransportDesc:
    "Transportasi barang Anda melalui jalan darat menggunakan Armada kami",
  homeServiceLCL: "Less Container Load",
  homeServiceLCLDesc:
    "Kirim barang Anda tanpa harus memenuhi satu kontainer, lebih hemat & lebih flexibel.",
  homeServiceInternational: "International Shipment",
  homeServiceInternationalDesc:
    "Bekerjasama dengan TOLL Grup kami melayani pengiriman ke luar negara Indonesia.",
  homeServiceInsurance: "Asuransi MAG",
  homeServiceInsuranceDesc:
    "Lindungi barang Anda dari kehilangan dan kerusakan saat proses pengiriman.",
  homeServiceWarehousing: "Warehousing",
  homeServiceWarehousingDesc:
    "Gudang modern dengan lokasi strategis, dan memiliki akses cepat dari depo kontainer.",
  homeNewsCaption: "News & Activities",
  homeNewsTitle: "Our Latest Activities",
  homeNewsCTA: "Our Activities",
  homeNewsCTADetail: "Baca Selengkapnya",
  homeSocmedCaption: "Social Media",
  homeSocmedTitle: "Be Part of Our Community",
  homeSocmedCTA: "See More",
  homeBook: ["Tertarik?", "Mulai Pengirimanmu Sekarang"],
  homeBookCTA: "Book Now",

  // Commitment Page
  commitmentTitle: "Peduli untuk Komunitas dan Planet",
  commitmentHeader1: "Tanggung Jawab",
  commitmentDesc1: [
    "PT SPIL merupakan salah satu perusahaan shipping dan logistic yang menunjukan komitmennya terhadap prinsip-prinsip lingkungan, sosial dan tata kelola (ESG). Dengan pengalaman lebih dari 50 tahun, kami selalu berusaha dan belajar mendalami mengenai dampak sebuah bisnis terhadap bumi, melalui inisiatif ESG yang sudah disusun , kami berusaha untuk selalu melakukan pendekatan yang komprehensif terhadap keberlanjutan.",
    "Menerapkan teknologi dan praktek ramah lingkungan, SPIL memastikan perhitungan jejak karbon dan pengelolaan sumber daya yang bertanggung jawab. Di saat yang sama juga, upaya kami terhadap pemberdayaan sosial berfokus pada penciptaan tempat kerja yang inklusif, menghargai keberagaman, kesejahteraan karyawan dan secara aktif berkontribusi terhadap kemajuan komunitas di sekitarnya.",
    "Kami menjaga transparansi dan akuntabilitas, menumbuhkan kepercayaan di antara pemangku kepentingan dan berusaha melakukan sebuah perubahan yang berarti. Kami percaya tindakan kami ini dapat menginspirasi pihak lain untuk melakukan hal yang sama dan berkolaborasi bersama menuju masa depan yang lebih baik.",
  ],
  commitmentHeader2: "Apa yang sudah kami lakukan ?",
  commitmentDesc2:
    "Di PT SPIL, kami lebih dari sekedar perusahaan; kami adalah perusahaan yang mendukung Lingkungan, Sosial dan Tata kelola (ESG). Dengan komitmen kami yang nyata terhadap Keberlanjutan, tindakan kami mencerminkan keyakinan kami dalam menciptakan dampak positif terhadap dunia tempat kita tinggal sekarang.",
  commitmentSlider1:
    "Kebiasaan Kecil yang Dapat Mengubah Dunia dengan Mesin Daur Ulang Botol Plastik",
  commitmentSlider2:
    "Berkomitmen Melindungi Anak dari Kekerasan di Hari Anak Nasional",
  commitmentSlider3: "Peduli Kesehatan dan Kebersihan Anak",
  commitmentSlider4: "Tumbuhkan Harapan Baru pada Tanaman di Tahun Baru",
  commitmentSlider5: "Menebar Kebaikan Melalui Campaign Zero Hunger",
  commitmentSlider6: "SPIL Peduli Anak Negeri",
  commitmentModalTitle: "Unduh Report ESG",
  commitmentModalTitleCaption:
    "Isi informasi pribadi anda untuk mengunduh Laporan ESG",
  commitmentModalOTPTitle: "Masukan Kode OTP",
  commitmentModalOTPTitleCaption:
    "Cek email anda untuk mendapatkan 6 digit kode OTP.",
  commitmentModalCompanyName: "Nama Perusahaan",
  commitmentModalCompanyNamePlaceholder: "Nama Perusahaan",
  commitmentModalName: "Nama",
  commitmentModalNamePlaceholder: "Nama Lengkap",
  commitmentModalMaleTitle: "Bpk",
  commitmentModalFemaleTitle: "Ibu",
  commitmentModalWANumber: "Nomor telepon",
  commitmentModalWANumberPlaceholder: "Nomor telepon",
  commitmentModalEmail: "Email",
  commitmentModalEmailPlaceholder: "Email Aktif",
  commitmentModalSubmitCTA: "Lanjutkan",
  commitmentModalResendOTP: "Tidak mendapatkan kode?",
  commitmentModalTooltip: "Klik di sini untuk mengunduh",
  commitmentModalSubmitTitle: "Permintaan diterima!",
  commitmentModalSubmitDesc:
    "Permintaan file Anda telah berhasil kami terima. Kami akan segera menghubungi Anda melalui email dan memberikan pemberitahuan setelah disetujui.",

  // Company Page - About
  companyAboutTitle: "Tentang SPIL",
  companyAboutSubtitle:
    "Ketahui segala informasi terkait dengan PT Salam Pacific Indonesia Lines",
  companyAboutHeader: "Connecting Islands",
  companyAboutDesc: [
    "PT Salam Pacific Indonesia Lines (SPIL) merupakan salah satu perusahaan pelayaran petikemas yang berkantor pusat di Surabaya, Indonesia. SPIL merupakan perusahaan pengiriman petikemas berbasis teknologi terbesar di Indonesia & saat ini melayani lebih dari 38 pelabuhan yang tersebar di seluruh Indonesia.",
    "Perusahaan ini berdiri Pada tahun 1970, didukung dengan jaringan yang luas di seluruh Indonesia serta sumber daya yang berkualitas hingga sampai saat ini  SPIL terus berinovasi dan berkembang untuk memberikan pelayanan yang berkualitas untuk membantu bisnis Anda terus tumbuh dan berkembang. SPIL percaya bahwa inovasi yang berkelanjutan dapat membantu Anda untuk mengatasi kompleksitas lingkungan bisnis saat ini dan kami siap untuk menjadi mitra Anda dalam menghadapi tantangan global.",
  ],
  companyAboutVisi: "Visi",
  companyAboutVisiValue:
    "Menjadi perusahaan pelayaran terbaik yang menggerakkan perekonomian",
  companyAboutMisi: "Misi",
  companyAboutMisiValue:
    "Memberikan solusi transportasi dengan jaringan terluas didukung sumber daya berkualitas untuk kepuasan pelanggan",
  companyAboutSPILValues: "Nilai SPIL",
  companyAboutSPILValueIntegrity: "Integritas",
  companyAboutSPILValueCustomer: "Orientasi Pelanggan",
  companyAboutSPILValueCompetitive: "Kompetitif",
  companyAboutSPILValueTeamwork: "Kerjasama Tim",
  companyAboutSPILValueVisionary: "Visioner",

  // Company Page - History
  companyHistoryTitle: "Sejarah Perusahaan",
  companyHistorySubtitle: "Simak perkembangan SPIL dari masa ke masa.",
  companyHistory1970Title: "Awal Perjalanan",
  companyHistory1970Desc:
    "Perjalanan bermula pada tahun 1970 dengan dibentuknya PT SAMUDERA PACIFIC sebagai perusahaan jasa pengangkutan barang antar pulau.",
  companyHistory1980Title: "Kapal Pertama",
  companyHistory1980Desc:
    "Kapal pertama menandai awal mula lahirnya sebuah perusahaan pelayaran nasional bernama PT SAMUDERA PACIFIC INDAH RAYA (SPIR).",
  companyHistory1984Title: "Ekspansi SPIL",
  companyHistory1984Desc:
    "Perusahaan mengakuisisi saham PT SALAM SEJAHTERA yang berlokasi di Samarinda dan memindahkan kantor pusatnya ke Surabaya sebagai tanda lahirnya PT SALAM PACIFIC INDONESIA LINES (SPIL).",
  companyHistory1996Title: "Kontainerisasi SPIL",
  companyHistory1996Desc:
    "Di tahun 1996, SPIL mengembangkan bisnisnya yang berawal dari kapal curah menjadi pengiriman yang lebih efisien dengan menggunakan kontainer.",
  companyHistory2000Title: "Menjangkau Indonesia Timur",
  companyHistory2000Desc:
    "pada tahun ini PT SPIL merupakan pelayaran pertama yang melayani pengiriman ke Kota Sorong. Berkontribusi dalam pertumbuhan ekonomi dan pasar Indonesia Timur.",
  companyHistory2009Title: "Menghubungkan Indonesia",
  companyHistory2009Desc:
    "Dari kepercayaan pelanggan terhadap kami, di tahun ini SPIL telah memiliki lebih dari 20 cabang yang tersebar di seluruh penjuru negeri.",
  companyHistory2014Title: "Komitmen Kami",
  companyHistory2014Desc:
    "PT SPIL menerima beberapa penghargaan dari Pelindo, Kementrian Perhubungan, dan instansi-instansi lainnya. Hal ini adalah bukti dari komitmen PT SPIL untuk mewujudkan visinya sebagai penggerak perekonomian nasional, di bidang logistik dan transportasi.",
  companyHistory2017Title: "MYSPIL App",
  companyHistory2017Desc:
    "Peluncuran mySPIL sebagai aplikasi pertama di industri pelayaran dan logistik untuk menerapkan digitalisasi yang meningkatkan customer experience.",
  companyHistory2020Title: "International Freight Forwarding",
  companyHistory2020Desc:
    "Terbentuknya PT SPIL Toll Indonesia, sebuah kerja sama antara SPIL dan Toll Group (anggota dari Japan Post).",
  companyHistoryPresentTitle: "All In One Logistic Solutions",
  companyHistoryPresentDesc:
    "PT SPIL Menyediakan berbagai solusi logistik, mulai sea freight, air freight, hingga land transport. Dengan berbagai layanan yang ada, melalui satu platform.",

  // Company Page - Group
  companyGroupTitle: "Grup SPIL",
  companyGroupSubtitle:
    "Dengan perjalanan yang begitu panjang, kami terus berkembang untuk memenuhi semua kebutuhan logistik anda.",
  companyGroupCTA: "See More",
  companyGroupSPIL:
    "SPIL merupakan sebuah perusahaan shipping logistics (Shiplog) yang memiliki jaringan di seluruh wilayah Indonesia, memberikan solusi pengiriman logistik dan pelayaran untuk membantu bisnis Anda terus tumbuh dan berkembang.",
  companyGroupNPTI:
    "NPTI adalah sebuah perusahaan terminal kontainer yang berlokasi di Pelabuhan Tanjung Perak Surabaya, gerbang menuju Indonesia Timur. NPTI berkomitmen untuk menjalankan terminal secara efisien dan efektif menggunakan teknologi modern.",
  companyGroupNPH:
    "Berlokasi di Pelabuhan Tanjung Priok Jakarta, Adipurusa melayani terminal kontainer domestik bekerja sama dengan PT Nusantara Pelabuhan Handal Tbk., sebuah perusahaan terkemuka yang memberikan layanan pelabuhan secara lengkap.",
  companyGroupNYK:
    "Bersama dengan NYK, menyediakan layanan pengiriman domestik secara komprehensif untuk automotif dan alat berat.",
  companyGroupManalagi:
    "Meningkatnya permintaan untuk transportasi breakbulk domestik mendorong SPIL untuk mendirikan divisi bulk-nya, PT Pelayaran Mana Lagi. PT Pelayaran Mana Lagi saat ini memiliki dan mengoperasikan 12 armada kapal dengan berbagai jenis ukuran seperti Handysize, Supramax, Panamax dan juga Post-Panamax.",
  companyGroupDOK:
    "Hadir untuk melayani perbaikan kapal regional dengan mengutamakan keselamatan, kualitas, dan ketepatan waktu. Telah tersertifikasi ISO 9001, ISO 14001, OHSAS 18001 dan SMK3.",
  companyGroupTOLL:
    "PT SPIL bekerja sama dengan Toll Group, untuk menghadirkan solusi Third-Party Logistics (3PL). Layanan kami mencakup pengiriman domestik dan internasional, logistik kontrak, serta distribusi barang, didukung oleh infrastruktur terintegrasi dan teknologi berbasis data untuk meningkatkan efisiensi rantai pasok.",
  companyGroupVentures:
    "Membuka potensi untuk bertumbuh lebih cepat dalam era digital. Kami bertujuan untuk mendayagunakan dan mengembangkan ide-ide brilian dan cemerlang sehingga menjadi sebuah bentuk usaha yang sukses.",
  companyGroupTPIL:
    "PT TPIL didirikan pada tahun 2000 sebagai anak perusahaan dari grup SPIL. TPIL berkembang dari perusahaan pengiriman barang domestik menjadi salah satu perusahaan pertama yang menyediakan layanan yang komprehensif. Kami terus berkembang dan memiliki lebih dari 30 cabang di Indonesia.",
  companyGroupWarehouse:
    "SPIL Warehouse menghadirkan fasilitas pergudangan premium yang dirancang khusus sesuai kebutuhan operasional klien. Kami membangun gudang modern dengan fitur yang meningkatkan efisiensi dan efektivitas operasional setiap penyewa.",
  companyGroupRORO:
    "Kami menyediakan layanan pengiriman secara komprehensif untuk automotif dan alat berat.",
  companyGroupSPILUniv: "SPIL UNIVERSITY",

  // Company Page - Career
  companyCareerTitle: "Tumbuh Bersama",
  companyCareerListHeader: "Temukan Peluangmu",
  companyCareerTabProfessional: "Profesional",
  companyCareerTabCrew: "Kru Kapal",
  companyCareerTabIntern: "Kadet / Magang",
  companyCareerGreenerHeader:
    "Kami mencari Greeners, untuk bersama-sama menghijaukan samudra. Apakah kamu orangnya?",
  companyCareerGreenerDesc:
    "Temukan peluang baru untuk masa depan Anda dan bersama berkembang dengan nilai-nilai dan budaya kami.",
  companyCareerBusinessHeader: "Bisnis yang Prima",
  companyCareerBusinessDesc:
    "Kami bangga telah menjadi bagian kesuksesan para pelanggan kami selama lebih dari 50 tahun, membuktikan kualitas, konsistensi, dan keberlanjutan bisnis kami untuk terus menggerakan perekonomian nasional.",
  companyCareerGrowthHeader: "Berkembang Bersama",
  companyCareerGrowthDesc:
    "Di SPIL, kami percaya Anda adalah elemen penting dari kesuksesan dan keberlanjutan kami.  Tidak hanya rutinitas pekerjaan, SPIL juga menyediakan berbagai pembelajaran dan pelatihan yang disesuaikan dengan kompetensi dan kebutuhan Anda. Menggapai karir yang Anda dambakan bukan lagi sekedar impian.",
  companyCareerInovationHeader: "Selalu Berinovasi",
  companyCareerInovationDesc:
    "Ibarat ombak laut yang tidak berhenti bergerak, SPIL senantiasa berinovasi untuk mengikuti arus perkembangan jaman. Budaya kerja yang dinamis dan mendorong masing-masing karyawan untuk berani menyuarakan aspirasinya, di sini Anda dapat menjadi bagian dari sebuah perubahan.",
  companyCareerConcernHeader: "Kepedulian Sesama",
  companyCareerConcernDesc:
    "Greeners bukan sekedar warna, sebutan atau ikon, tapi juga kekeluargaan. Kami menjunjung tinggi keberagaman dan peduli dengan sesama. Jarak yang terbentang di antara kantor-kantor kami yang terletak dari Indonesia barat hingga timur, tidak menjadi halangan untuk tetap bersatu dan berjuang bersama.",
  companyCareerMomentHeader: "Momen Spesial di Lingkungan Spesial",

  // Company Page - Career - Form
  companyCareerFormPersonalData: "Data personal",
  companyCareerFormJobTitle: "Nama Jabatan",
  companyCareerFormIdentityNumber: "Nomor Identitas",
  companyCareerFormFullName: "Nama Lengkap",
  companyCareerFormSex: "Jenis Kelamin",
  companyCareerFormPOB: "Tempat Lahir",
  companyCareerFormDOB: "Tanggal Lahir",
  companyCareerFormCitizenship: "Kewarganegaraan",
  companyCareerFormAddress: "Alamat Domisili",
  companyCareerFormMobile: "Nomor Telpon",
  companyCareerFormEmail: "Alamat Email",
  companyCareerFormSalary: "Ekspektasi Gaji",
  companyCareerFormFormalEducation: "Edukasi Formal",
  companyCareerFormWorkExperience: "Pengalaman Kerja",
  companyCareerFormShipExp: "Pengalaman Kapal",
  companyCareerFormShipCompetency: "Ijasah Kelautan",
  companyCareerFormCity: "Kota Identitas",
  companyCareerFormRecFrom: "Asal Lamaran",

  // Company Page - Career Details
  companyCarrerDetailBack: "kembali ke daftar karir",
  companyCareerDetailJobHeader: "Rincian pekerjaan",
  companyCareerDetailLevel: "Tingkatan",
  companyCareerDetailLocation: "Lokasi",
  companyCareerDetailType: "Tipe",
  companyCareerDetailDesc: "Deskripsi",
  companyCareerDetailQualification: "Kualifikasi",
  companyCareerDetailEducation: "Edukasi",
  companyCareerDetailExperience: "Pengalaman",
  companyCareerDetailCTA: "Lamar Pekerjaan Ini",

  // Service Page - Type
  serviceTypeTitle: "One Stop Logistics Solutions",
  serviceTypeServices: "Services Type",
  serviceTypePTPHeader: "Port to Port",
  serviceTypePTPDesc:
    "Port to Port dapat diartikan dimana shipper atau pengirim barang mengantarkan barang kirimannya ke perusahaan pengiriman yang telah ditunjuk ditempat asal shipper, dan dikirim ke port penerima barang. Serta penerima barang atau consignee tersebut juga mengambil sendiri di port yang telah ditentukan oleh consignee sendiri.",
  serviceTypeDTDHeader: "Door to Door",
  serviceTypeDTDDesc:
    "Door to Door service dalam dunia cargo merupakan sebuah layanan dengan metode pengiriman sebuah barang akan dijemput atau di-pickup pada lokasi pengirim dan diantar menuju lokasi penerima barang atau consignee.",
  serviceTypeLogistic: "Logistics Solutions",
  serviceTypeSeaFreightHeader: "Sea Freight",
  serviceTypeSeaFreightDesc:
    "Sea Freight Services merupakan pengiriman barang melewati perairan laut. Sea Freights merupakan pilihan ekonomis untuk mengirimkan barang dengan volume besar dan jarak yang jauh.",
  serviceTypeAirFreightHeader: "Air Freight",
  serviceTypeAirFreightDesc:
    "Air Freight Services menawarkan pengiriman barang dalam hitungan jam,  jangkuan pengiriman yang lebih luas & aman. Saat ini sudah terintegrasi dan dapat diakses pada aplikasi mySPIL Reloaded.",
  serviceTypeLandTransportHeader: "Land Transport",
  serviceTypeLandTransportDesc:
    "Pengiriman Land Transport mempunyai fleksibilitas yang tinggi berdasarkan waktu, kebutuhan dan Area. Land Transport memiliki jangkauan luas hingga dapat menggapai seluruh wilayah, mulai dari daerah kecil seperti desa, hingga ke seluruh kota. ",
  serviceTypeOther: "Other Services",
  serviceTypeInternationalHeader: "International Freight Forwarder",
  serviceTypeInternationalDesc:
    "International Freight Forwarder adalah istilah yang digunakan untuk menggambarkan pengiriman paket atau kelompok pengiriman paket dimana paket tersebut diambil dari satu negara dan dikirim ke alamat di negara lain. Dalam hal ini, SPIL bersinergi dengan TOLL menjadi SPIL TOLL Indonesia.",
  serviceTypeWarehouseHeader: "Warehouse",
  serviceTypeWarehouseDesc:
    "Sebagai perusahaan layanan logistik yang terintegrasi, SPIL menyediakan gudang modern yang didukung dengan konsep desain modern, lokasi strategis, dan memiliki akses cepat dari depo kontainer untuk pengiriman antar pulau.",
  serviceTypeInsuranceHeader: "Asuransi MAG",
  serviceTypeInsuranceDesc:
    "ASURANSI MAG memberikan perlindungan terhadap kehilangan dan kerusakan pada kargo yang akibat dari bahaya laut yang terjadi selama pengangkutan kargo Anda, baik melalui laut maupun darat. Dengan menyertakan Asuransi MAG  Anda akan lebih tenang ketika mengirimkan barang bersama SPIL. Untuk lebih lanjut dapat dilihat",

  // Service Page - Guide
  serviceGuideHeaderTitle: "Mencari Informasi atau Bantuan?",
  serviceGuideHeaderFormTitle: "Bagaimana kami bisa membantu ?",
  serviceGuideHeaderFormPlaceholder:
    "Masukkan sebuah topik, seperti pembayaran, pengiriman, segel, dll.",
  serviceGuideHeaderCTA: "Cari",
  serviceGuideTopicHeader: "Cari Berdasarkan Topik",
  serviceGuideSeeMore: "Lihat lebih banyak",
  serviceGuideSeeLess: "Lihat lebih sedikit",
  serviceGuideNoDataFound: "Panduan tidak ditemukan",
  serviceGuideFirstSender: "Pengirim Pertama",
  serviceGuideFirstSenderOpt1: "Pengiriman pertama",
  serviceGuideFirstSenderOpt2: "Tentang dangerous goods",
  serviceGuidePaymentMethod: "Cara Pembayaran",
  serviceGuidePaymentMethodOpt1: "Metode Pembayaran",
  serviceGuidePaymentMethodOpt2: "Pembayaran melalui bank yang diterima SPIL",
  serviceGuidePaymentMethodOpt3: "Akses myFinance",
  serviceGuidePaymentMethodOpt4: "Pembayaran dengan sistem kredit",
  serviceGuideSeal: "Segel",
  serviceGuideSealOpt1: "Pembelian segel pada mySPIL Reloaded",
  serviceGuideSealOpt2: "Pembelian segel pada mySPIL Reloaded (pickup)",
  serviceGuideAirFreight: "Air Freight",
  serviceGuideAirFreightOpt1: "Layanan Air Freight kami",
  serviceGuideAirFreightOpt2: "Cara kerja layanan Air Freight",
  serviceGuideAirFreightOpt3: "Keuntungan menggunakan layanan Air Freight",
  serviceGuideAirFreightOpt4: "Jenis kargo Air Freight",
  serviceGuideMySPILReloaded: "mySPIL Reloaded",
  serviceGuideMySPILReloadedOpt1: "Registrasi akun mySPIL",
  serviceGuideMySPILReloadedOpt2: "Tipe hak akses mySPIL setelah registrasi",
  serviceGuideMySPILReloadedOpt3: "Pengajuan tipe hak akses mySPIL",
  serviceGuideMySPILReloadedOpt4: "Keuntungan menggunakan mySPIL",
  serviceGuideMyBooking: "myBooking",
  serviceGuideMyBookingOpt1: "Fitur Quick Booking",
  serviceGuideMyBookingOpt2: "Tipe hak akses mySPIL setelah registrasi",
  serviceGuideMyBookingOpt3: "Pengajuan tipe hak akses mySPIL",
  serviceGuideMyBookingOpt4: "Keuntungan menggunakan mySPIL",
  serviceGuideMyDO: "myDO",
  serviceGuideMyDOOpt1: "Pengajuan eDO menggunakan Shippper Confirmation",
  serviceGuideMyDOOpt2: "Mendapatkan verification code",
  serviceGuideMyDOOpt3: "Pengajuan perpanjangan eDO",
  serviceGuideMyDOOpt4: "Pembayaran eDO",
  serviceGuideMyShipment: "myShipment",
  serviceGuideMyShipmentOpt1: "Membuat e-SI (Shipping Instruction)",
  serviceGuideMyShipmentOpt2: "Mengakses draft Shipping Instruction",
  serviceGuideMyShipmentOpt3:
    "Mengubah Shipping Instruction yang telah diinput",
  serviceGuideMyShipmentOpt4: "Mengetahui BL sudah diproses",
  serviceGuideMySPILPoints: "mySPIL Points",
  serviceGuideMySPILPointsOpt1: "Tentang mySPIL Points",
  serviceGuideMySPILPointsOpt2: "Cara Mendapatkan mySPIL Points",
  serviceGuideMySPILPointsOpt3: "Perhitungan Nilai mySPIL Points",
  serviceGuideMySPILPointsOpt4: "Masa Berlaku mySPIL Points",
  serviceGuideGuarantee: "Jaminan & Klaim",
  serviceGuideGuaranteeOpt1: "Klaim Jaminan Kontainer pada mySPIL",
  serviceGuideGuaranteeOpt2: "Melakukan Claim pada mySPIL Reloaded",
  serviceGuideBill: "Bill Payments & Topup",
  serviceGuideBillOpt1: "Penjelasan Bill Payments & Topup",
  serviceGuideBillOpt2: "Fitur Bill Payments & Topup",
  serviceGuideBillOpt3: "Melakukan Bill Payments & Topup",
  serviceGuideMySPILCall: "mySPIL Call",
  serviceGuideMySPILCallOpt1: "Fitur mySPIL Call",
  serviceGuideMySPILCallOpt2: "Melakukan panggilan menggunakan mySPIL Call",
  serviceGuideMySPILCallOpt3: "Keuntungan menggunakan mySPIL Call",
  serviceCTAHeader: "Butuh Bantuan Menyelesaikan Permasalahanmu?",
  serviceCTA: "Kontak Kami",

  // Service Page - Guide Detail
  serviceGuideDetailCTABack: "kembali ke daftar topik",
  serviceGuideChoosenTopic: "Topik Pilihan",

  // Service Page - Route and Schedule
  serviceRouteHeaderTitle: "Jadwal Kapal",
  serviceRouteHeaderFormTitlePOL: "Port of Loading",
  serviceRouteHeaderFormPlaceholderPOL: "Pilih Kota Asal",
  serviceRouteHeaderFormTitlePOD: "Port of Discharge",
  serviceRouteHeaderFormPlaceholderPOD: "Pilih Kota Tujuan",
  serviceRouteHeaderCTA: "Book Now",
  serviceRouteAvailableSchedule: "Jadwal Kapal Tersedia",
  serviceRouteFreq: "Frekuensi",
  serviceRouteChooseArea: "Pilih Area Cabang",

  // Contact Us Page
  contactWhatsappDesc:
    "Hubungi Whatsapp kami untuk mendapatkan respon yang akurat",
  contactWhatsappCTA: "Chat Now",
  contactCSDesc:
    "Customer Service SPIL siap membantu segala yang anda butuhkan.",
  contactCSCTA: "Call CS",
  contactEmailTitle: "Kirimkan Pesan",
  contactEmailDesc:
    "Ada beberapa hal yang ingin anda tanyakan? Kirim detailnya melalui pesan.",
  contactEmailCTA: "Kirim",
  contactVisitUs: "Kunjungi Kami",
  contactOurBranch: "Cabang Kami",
  contactContactUs: "Hubungi Kami",
  contactFormName: "Nama",
  contactFormNamePlaceholder: "Nama Lengkap",
  contactFormWA: "Nomor Whatsapp",
  contactFormWAPlaceholder: "Nomor Whatsapp Aktif",
  contactFormEmail: "Email",
  contactFormEmailPlaceholder: "Email Aktif",
  contactFormRequire: "Keperluan",
  contactFormRequirePlaceholder: "Pilih Keperluan",
  contactFormServiceType: "Tipe Pengiriman",
  contactFormServiceTypePlaceholder: "Pilih Tipe Pengiriman",
  contactFormFCL: "Full Container Load (FCL)",
  contactFormLCL: "Less than Container Load (LCL)",
  contactFormFTL: "Full Truck Load (FTL)",
  contactFormLTL: "Less than Truck Load (LTL)",
  contactFormAirFreight: "Air Freight",
  contactFormOther: "Lainnya",
  contactFormRoute: "Rute",
  contactFormRouteOrigin: "Asal",
  contactFormRouteDestination: "Tujuan",
  contactFormMessage: "Pesan",
  contactFormMessagePlaceholder: "Saya membutuhkan ...",
  contactFormSource: "Dari mana Anda mengetahui informasi tentang SPIL?",

  // mySPILReloaded Page
  mySPILReloadedTitle: "Layanan Logistik dalam Genggaman",
  mySPILReloadedDesc:
    "PT Salam Pacific Indonesia Lines (SPIL) melalui aplikasi mySPIL Reloaded, terus berinovasi untuk mengembangkan Logistics Super App yang pertama dan terlengkap di Indonesia. mySPIL Reloaded menyediakan layanan multimoda terlengkap untuk bisnis logistik Indonesia, pengiriman barang melalui jalur laut, darat, dan udara. Diluncurkan pada tahun 2017, dan hingga saat ini terus bertransformasi untuk menjawab perubahan zaman dan kebutuhan pelanggan.",
  mySPILReloadedFeature: "Fitur Utama mySPIL Reloaded",
  mySPILReloadedWhy: "Mengapa mySPIL Reloaded?",
  mySPILReloadedEfficientHeader: "Efisien dan Mudah Digunakan",
  mySPILReloadedEfficientDesc:
    "Tampilan aplikasi mySPIL Reloaded yang sederhana dapat memudahkan dan juga menghemat waktu Anda dalam menggunakannya.",
  mySPILReloadedFeatureHeader: "Beragam Fitur Layanan dalam Satu Platform",
  mySPILReloadedFeatureDesc:
    "mySPIL Reloaded dilengkapi dengan beragam fitur untuk dapat melakukan pemesanan dengan praktis, nyaman, dan aman.",
  mySPILReloadedRewardHeader: "Reward dan Bonus Penggunaan",
  mySPILReloadedRewardDesc:
    "Aplikasi mySPIL Reloaded juga dilengkapi reward dan bonus bagi pengguna yaitu mySPIL poin dan mySPIL Referral Program.",
  mySPILReloadedCTA: "Daftar mySPIL Reloaded",

  // News Page
  newsTitle: "Berita & Aktivitas",
  newsCTABack: "kembali ke daftar berita",
  newsLatestNews: "Berita Terbaru",
  newsCategory: "Kategori",
  newsShare: "Bagikan",
  newsArchive: "Arsip",
  newsFilterArchive: "Anda sedang melihat berita pada tahun ",
  newsFilterCategory: "Anda sedang melihat berita dengan kategori ",

  // Outlook Page
  outlookTitle: "Dapatkan Wawasan Baru",
  outlookLatest: "Wawasan Terbaru",
  outlookCTABack: "kembali ke daftar wawasan",

  // SPILDex Page
  spildexBadge: "API INTEGRATION PLATFORM",
  spildexHeroTitle: "Kendalikan Seluruh Informasi Pengiriman Dalam Satu Sistem",
  spildexHeroDesc:
    "SPILDEX menghubungkan ERP perusahaan Anda dengan ekosistem digital SPIL dan memberikan visibilitas shipment secara real-time tanpa proses manual.",
  spildexBtnDemo: "Jadwalkan Demo",
  spildexBtnWork: "Lihat Cara Kerja",
  spildexStat1Val: "34+",
  spildexStat1Label: "Perusahaan Terintegrasi",
  spildexStat2Val: "77 Juta+",
  spildexStat2Label: "API Request",
  spildexStat3Val: "99.9%",
  spildexStat3Label: "System Uptime",
  spildexStat4Val: "24/7",
  spildexStat4Label: "Real-Time Monitoring",
  spildexProblemTitle1: "Ketika Data <br/>Tidak Terhubung,",
  spildexProblemTitle2: "Operasional <br/>Menjadi Lambat",
  spildexProblemSub:
    "Banyak perusahaan menghadapi tantangan yang sama setiap hari.",
  spildexAkibat: "Akibatnya?",
  spildexAkibatDesc:
    "Operasional berjalan lebih lambat, biaya meningkat, dan peluang untuk mengambil keputusan cepat menjadi hilang",
  spildexCard1: "<b>Status shipment</b> <b>tersebar</b> di berbagai platform",
  spildexCard2: "Tim harus mengecek <b>informasi secara manual</b>",
  spildexCard3: "<b>Customer terus</b> <b>meminta update</b> posisi barang",
  spildexCard4: "Laporan operasional <b>membutuhkan waktu berjam-jam</b>",
  spildexCard5:
    "<b>Informasi penting</b> <b>terlambat</b> sampai ke pengambil keputusan",
  spildexSolutionTitle1: "SPILDEX",
  spildexSolutionTitle2: "Solusi Integrasi Data Logistik",
  spildexSolutionDesc:
    "Platform integrasi data yang memungkinkan sistem perusahaan Anda berkomunikasi langsung dengan layanan digital SPIL melalui API dan Webhook Real-Time",
  spildexSolutionFooter:
    "Setiap perubahan data akan otomatis tersedia di sistem Anda tanpa perlu input ulang.",
  spildexVideoTitle: "Bagaimana <b>SPILDEX Membantu Anda?</b>",
  spildexIntegrationTitle: "Apa yang Dapat Anda <b>Integrasikan?</b>",
  spildexTrustedTitle: "Dipercaya oleh <br/><b>Perusahaan Terkemuka</b>",
  spildexTrustedAndManyMore: "serta berbagai perusahaan lainnya",
  spildexCTATitle: "Siap Mengintegrasikan Sistem Anda?",
  spildexCTADesc:
    "Tim kami siap membantu Anda memahami bagaimana SPILDEX dapat terhubung dengan ERP atau TMS yang digunakan perusahaan Anda.",
  spildexCardVesselTitle: "Vessel Schedule",
  spildexCardVesselDesc:
    "Akses jadwal kapal terbaru secara real-time langsung dari sistem perusahaan Anda.",
  spildexCardBookingTitle: "Booking Integration",
  spildexCardBookingDesc:
    "Lakukan proses booking tanpa harus berpindah aplikasi.",
  spildexCardTrackTitle: "Track & Trace",
  spildexCardTrackDesc:
    "Pantau posisi shipment dan pergerakan kontainer secara otomatis.",
  spildexCardShipmentTitle: "E-Shipment Instruction",
  spildexCardShipmentDesc:
    "Kirim instruksi pengiriman langsung dari sistem internal perusahaan.",
  spildexCardInvoiceTitle: "Statement of Account & Invoice",
  spildexCardInvoiceDesc:
    "Monitoring tagihan dan invoice menjadi lebih mudah dan terpusat.",
  spildexCardPaymentTitle: "E-Payment Integration",
  spildexCardPaymentDesc:
    "Integrasikan proses pembayaran dengan alur operasional perusahaan.",

  spildexTitle: "Stay Updated, Stay Connected",
  spildexDesc:
    "SPILDEX merupakan sebuah layanan khusus untuk Perusahaan dan menyediakan Application Programming Interface (API) yang dapat terintegrasi dengan sistem Enterprise Resource Planning (ERP) dari sebuah perusahaan untuk memudahkan akses data secara real time dengan aman tanpa harus mengetahui proses internal masing-masing perusahaan. Akses data tersebut meliputi vessel schedule, booking list and status, track and trace, statement of account, invoice, dan online payment (via virtual account) dengan kemudahan mengolah informasi sesuai dengan format yang diinginkan oleh perusahaan.",
  spildexVesselHeader: "Vessel Schedule",
  spildexVesselDesc:
    "Anda dapat dengan mudah mengakses jadwal kapal melalui fitur Vessel Schedule dan juga mengetahui aktifitas kapal berangkat, datang dan sandar di aplikasi yang digunakan perusahaan Anda dengan integrasi API dan ERP.",
  spildexPaymentHeader: "e-Payment",
  spildexPaymentDesc:
    "Gunakan fitur pembayaran online (via Virtual Account) untuk melakukan pembayaran yang lebih praktis dan menghemat waktu Anda karena tidak perlu datang ke kantor SPIL.",
  spildexMyBookingHeader: "myBooking",
  spildexMyBookingDesc:
    "Booking semakin mudah dengan fitur Booking List & Status, Anda tidak perlu lagi mengunduh berbagai file dari SPIL hanya untuk melakukan booking, selain itu Anda juga dapat melihat status booking secara real time.",
  spildexShipmentHeader: "e-Shipment Instruction",
  spildexShipmentDesc:
    "Dengan fitur Statement of Account, Anda dapat melihat tagihan pengiriman langsung dari aplikasi perusahaan, tanpa perlu membuka aplikasi lainnya.",
  spildexTraceHeader: "Track and Trace",
  spildexTraceDesc:
    "Gunakan fitur Track & Trace untuk melacak posisi terkini pengiriman Anda dengan memasukkan salah satu informasi dari nomor kontainer, nomor BL, nama kapal, nama pelabuhan asal dan tujuan, atau kode booking.",
  spildexWhy: ["Mengapa", "SPILDex"],
  spildexServiceHeader: "Various Service",
  spildexServiceDesc:
    "Jadwal kapal, Daftar pemesanan, Track & Trace, Riwayat pembayaran, dan Pembayaran online. Semua informasi yang Anda butuhkan ada dalam jangkauan Anda.",
  spildexWebhooksHeader: "Webhooks secara Real-Time",
  spildexWebhooksDesc:
    "Dengan API kami, Anda dapat mengakses data dalam ERP Anda secara real-time dan menerima callback notifikasi seperti pergerakan kontainer, keberangkatan kapal, dan masih banyak lagi.",
  spildexCustomHeader: "Customized",
  spildexCustomDesc:
    "Tampilan setiap fitur di aplikasi dapat disesuaikan dengan format yang diinginkan oleh Perusahaan.",
  spildexOperationHeader: "Operational Efficiency",
  spildexOperationDesc:
    "Dengan semua fitur di atas, maka dapat dipastikan bahwa segala proses khususnya operational akan berjalan lebih efisien.",
  spildexInterest: [
    "Tertarik?",
    "Segera Integrasikan Bisnis Anda dengan SPILDEX",
  ],
  spildexCTA: "Kontak Kami",

  // Instant Quotes
  iqNavHome: "Beranda",
  iqNavAboutUs: "Tentang Kami",
  iqNavOurCust: "Pelanggan Kami",
  iqNavPromo: "Ambil Promo",
  iqNavServices: "Layanan Kami",
  iqNavAwards: "Penghargaan",

  iqHeroTitle:
    "Pengiriman Tepat Waktu & Real Time Tracking ke Seluruh Indonesia",
  iqHeroSubtitle:
    "Kini Anda bisa kirim barang lewat laut ke luar pulau tanpa bingung soal jadwal, tarif, atau status kiriman. Semua proses dari booking, pelacakan, hingga laporan bisa dilakukan sendiri dalam satu aplikasi Digital, mySPIL Reloaded.",
  iqHeroCTA: "Dapatkan Diskon",

  iqAboutTitle:
    "SPIL jadi pilihan utama untuk ekspedisi laut, EMKL, dan cargo antar <span class='text-primary'>pulau sejak 1970</span>",
  iqAboutSubtitle:
    "Dengan skala armada dan infrastruktur ini, SPIL mampu melayani ekspedisi laut secara efisien, terjadwal, dan terkoneksi penuh ke seluruh Indonesia.",
  iqAboutOpt1Title: "60+ Kapal Kontainer",
  iqAboutOpt1Desc: "Kapasitas hingga 60.000 TEUs",
  iqAboutOpt2Title: "37+ Depo Kontainer",
  iqAboutOpt2Desc: "Mempercepat bongkar-muat dan distribusi",
  iqAboutOpt3Title: "130+ Prime Mover & Trailer",
  iqAboutOpt3Desc: "Melayani Pengiriman ke Daerah Besar dan Terpencil",
  iqAboutOpt4Title: "2 Terminal Operator: Jakarta & Surabaya",
  iqAboutOpt4Desc: "Menghubungkan jalur laut nasional",

  iqRouteTitle:
    "Jangkauan dari Surabaya & Jakarta ke <span class='text-primary'>40+ Pelabuhan</span> di Seluruh Indonesia",
  iqRouteSubtitle:
    "SPIL melayani rute dari pelabuhan utama Jakarta & Surabaya ke seluruh Indonesia dari Belawan, Batam, Pontianak, hingga Jayapura & Merauke. Cocok untuk pengiriman skala kecil hingga menengah dengan sistem pelacakan digital, jadwal pasti, dan tarif kompetitif.",

  iqTrustedTitle: "Trusted By",
  iqTrustedSubtitle:
    "Dengan perjalanan <span class='text-primary font-weight-bold'>lebih dari 50 tahun</span>, SPIL telah dipercaya oleh berbagai rekanan.",

  iqPromoTitle: "Dapatkan Diskon Hingga 800 ribu rupiah per kontainer !",
  iqPromoSubtitle:
    "Cuma butuh waktu 1 menit, untuk booking melalui Instant Quote.",
  iqPromoCTA: "Klaim Diskon Anda",

  iqAwardTitle: "Perusahaan Kapal Komersial Pertama ",
  iqAwardSubtitle: "di Indonesia yang Tersertifikasi ISO 14001 oleh MURI",
  iqAwardDesc:
    "SPIL diakui secara nasional atas komitmennya terhadap standar lingkungan global dalam industri pelayaran komersial. Penghargaan ini menegaskan posisi SPIL sebagai pelopor ekspedisi laut yang bertanggung jawab dan berkelanjutan.",

  iqCTATitle: "Bergabung<br/>di WhatsApp Channel SPIL!<br/>Dapatkan:",
  iqCTABenefit1: "<b>Insight logistic</b> & supply chain terbaru",
  iqCTABenefit2: "<b>Info promo</b> & layanan inovatif SPIL",
  iqCTABenefit3: "<b>Tips efisiensi pengiriman</b> & rantai pasok",
  iqCTAButton: "Gabung Sekarang",

  // TPIL
  tpilServiceTitle: "TPIL Logistics",
  tpilServiceDescription:
    "TPIL Logistics didirikan pada tahun 2000 sebagai bagian dari SPIL Group, yang fokus pada pengiriman barang di dalam negeri. Dengan kantor pusat di Jakarta, TPIL Logistics kini hadir di lebih dari 37 lokasi SPIL di seluruh Indonesia. Pada tahun 2018, TPIL Logistics dan SPIL Shipping melakukan kolaborasi yang memperkuat sinergi di antara keduanya. Langkah ini memungkinkan keduanya untuk menawarkan solusi logistik yang komprehensif, mulai dari hulu hingga hilir, menjadikannya penyedia layanan logistik yang terintegrasi untuk pasar domestik.",
  tpilServiceScope: "Cakupan Layanan/Layanan Kami",
  tpilServiceBuyerTitle: "Buyer's consolidation",
  tpilServiceBuyerDescription:
    "Efisiensikan rantai pasok Anda dengan layanan buyer's consolidation kami, menggabungkan beberapa pengiriman dari berbagai pelanggan menjadi satu kontainer untuk mengoptimalkan biaya dan efisiensi pengiriman.",
  tpilServiceLCLTitle: "LCL consolidation",
  tpilServiceLCLDescription:
    "Ideal untuk pengiriman yang lebih kecil, konsolidasi LCL (Less than Container Load) kami memungkinkan Anda berbagi ruang kontainer dengan orang lain, menawarkan fleksibilitas dan penghematan biaya.",
  tpilServiceDTDTitle: "Door to Door delivery",
  tpilServiceDTDDescription:
    "Nikmati layanan logistik yang mudah dan praktis dengan Pengiriman Door-to-Door kami, yang mencakup setiap kebutuhan bisnis Anda mulai dari pengambilan hingga pengantaran ke tujuan akhir.",
  tpilServiceBulkTitle: "Bulk delivery",
  tpilServiceBulkDescription:
    "Layanan Bulk Delivery/Kargo Curah kami dirancang khusus untuk kargo dalam jumlah besar yang tidak dikemas, memastikan transportasi yang aman dan efisien untuk komoditas seperti biji-bijian, mineral, atau bahan kimia.",
  tpilServiceTallyTitle: "Tally services",
  tpilServiceTallyDescription:
    "Kami menyediakan Tally Services yang andal untuk memastikan penghitungan dan dokumentasi kargo yang akurat selama pemuatan dan pembongkaran, mendukung transparansi dan akuntabilitas.",
  tpilServiceSCFTitle: "Specialize SCF Trucking",
  tpilServiceSCFDescription:
    "Pindahkan kargo Anda dengan layanan Truk SCF kami—aman, tepat waktu, dan efisien.",
  tpilServiceMultiDropTitle: "Multi-drop delivery",
  tpilServiceMultiDropDescription:
    "Tingkatkan efisiensi pengiriman dengan layanan Multi-drop delivery kami, yang memungkinkan beberapa pemberhentian dalam satu rute, sangat cocok untuk distributor dan jaringan ritel.",

  tpilInfoTitle: "Logistik Nasional dengan Profesionalisme dan Keahlian",
  tpilInfoDescription:
    "Berbekal pengalaman dan pemahaman mendalam tentang logistik, kami tumbuh menjadi mitra yang dapat andalkan dan efisien. Tim kami memahami kompleksitas logistik dan dapat memberikan solusi yang sesuai dengan kebutuhan Anda dengan presisi dan profesionalisme untuk setiap pengiriman.",
  tpilInfoTitle1: "20",
  tpilInfoDesc1: "Tahun Pengalaman",
  tpilInfoTitle2: "220",
  tpilInfoDesc2: "Personel Profesional",
  tpilInfoTitle3: "42",
  tpilInfoDesc3: "Kota Dijangkau",

  tpilCertificateTitleInfo: "MENAMPILKAN KEUNGGULAN",
  tpilCertificateTitle: "Sertifikat TPIL",
  tpilCertificateName1: "Sertifikat Halal",
  tpilCertificateCode1: "Certificate No: ID00410013512621223",
  tpilCertificateDesc1:
    "Pada tahun 2023, TPIL secara resmi menerima sertifikat Halalnya, menandai tonggak sejarah dalam perjalanannya menuju standar Halal di industri logistik.",
  tpilCertificateName2: "ISO 14001 Manajemen Lingkungan",
  tpilCertificateCode2: "Certificate No.: QAIS-E-INDO-PS-06.25.068",
  tpilCertificateDesc2:
    "Bersertifikasi untuk mengelola tanggung jawab lingkungan guna mengurangi dampak dan mendukung keberlanjutan.",
  tpilCertificateName3: "ISO 45001 Manajemen Kesehatan & Keselamatan",
  tpilCertificateCode3: "Certificate No.: 621002",
  tpilCertificateDesc3:
    "Bersertifikasi untuk memastikan lingkungan kerja yang aman dan sehat melalui pengendalian risiko proaktif.",
  tpilCertificateName4: "ISO 9001 Manajemen Kualitas",
  tpilCertificateCode4: "Certificate No.: 621001",
  tpilCertificateDesc4:
    "Bersertifikasi karena secara konsisten menghasilkan produk dan layanan berkualitas melalui sistem yang efisien",

  tpilCTA: "Butuh solusi untuk memenuhi kebutuhan Anda?",

  // SPIL Prime
  primeHeroTitle:
    "Pengiriman Terjadwal dengan <span style='color: #35B031'>Prioritas Space</span>",
  primeHeroSubtitle:
    "Booking melalui sistem terintegrasi dengan prioritas pengiriman. Dirancang untuk bisnis yang tidak bisa mengambil risiko kekurangan space, termasuk di periode peak season.",
  primeHeroTnC: "*Syarat & Ketentuan Berlaku",
  primeHeroCTA: "Cek Ketersediaan Space",

  primeFeaturesTitle:
    "Kepastian <span style='color: #35B031'>Space</span>. Prioritas <span style='color: #00B14F'>Pengiriman</span>. Konfirmasi <span style='color: #00B14F'>Instan</span>",
  primeFeaturesSubtitle:
    "<span style='color: #35B031'>SPIL PRIME</span> memastikan pengiriman Anda tetap berjalan sesuai jadwal, bahkan saat periode dengan permintaan tinggi",
  primeFeaturesShip: "Space Kapal<br/>Dijamin",
  primeFeaturesDepo: "Prioritas Handling dan<br/>Proses di Depo",
  primeFeaturesContainer: "Kontainer Siap Pakai<br/>dan Terstandarisasi",

  primeRouteTitle:
    "<span style='color: #35B031'>Kepastian Pengiriman</span><br/>di Seluruh Jaringan Rute SPIL",
  primeRouteSubtitle:
    "Tersedia untuk rute strategis dari Jakarta & Surabaya ke lebih dari <b>40 pelabuhan di seluruh Indonesia.</b>",
  primeRouteCTA: "Cek Rute Anda",

  primePromoTitle1:
    "Pastikan <span style='color: #35B031'>Ketersediaan Space</span> Pengiriman Anda",
  primePromoSubtitle1:
    "Isi data pengiriman Anda. Tim kami akan mengkonfirmasi ketersediaan dan prioritas layanan sebelum pengiriman dilakukan.",
  primePromoTitle2:
    "Bayar untuk <span style='color: #00B14F'>Kepastian</span>. Bukan untuk <span style='color: #212121'>Resiko</span>.",
  primePromoSubtitle2:
    "<span>SPIL PRIME</span> adalah solusi manajemen risiko pengiriman, memberikan prioritas dan proteksi operasional saat permintaan tinggi dan jadwal ketat.",
  primePromoCTA: "Cek Ketersediaan Space",

  primeBookingTitle:
    "Bagaimana Cara Booking <span style='color: #35B031'>Prime?</span>",
  primeBookingSubtitle:
    "Booking mudah, cepat, dan terkonfirmasi instan melalui mySPIL.",
  primeBookingStep1: "Cari Jadwal & Route",
  primeBookingDesc1:
    "Login ke <b>www.myspil.com</b>, pilih menu Sea Freight, isi port asal dan tujuan, lalu klik Search.",
  primeBookingStep2: "Pilih Jadwal & Lanjutkan",
  primeBookingDesc2:
    "Pilih jadwal kapal yang sesuai dengan kebutuhan Anda, kemudian klik Prime Booking.",
  primeBookingStep3: "Konfirmasi & Selesai",
  primeBookingDesc3:
    "Review detail booking Anda, kemudian lanjutkan hingga order berhasil dikirim.",
  primeBookingBenefit1: "Mudah",
  primeBookingBenefitDesc1: "Proses praktis hanya beberapa langkah",
  primeBookingBenefit2: "Cepat",
  primeBookingBenefitDesc2: "Konfirmasi instan tanpa menunggu",
  primeBookingBenefit3: "Aman",
  primeBookingBenefitDesc3: "Data terlindungi & transaksi terjamin",
  primeBookingBenefit4: "Transparan",
  primeBookingBenefitDesc4: "Informasi biaya & jadwal jelas sejak awal.",

  //New Menu Green Earth
  navGreenEarth: "Green Earth",
  greenEarthButton: "Lihat Selengkapnya",
  greenEarthButton2: "Baca Selengkapnya",
  greenEsgReport: "Unduh Laporan ESG",
  greenEsgModal: "Isi informasi pribadi Anda untuk mengunduh Laporan ESG.",
  greenEarthNewsText: "Berita Terbaru",
  greenEarthNewsVideo: "Vidio Terbaru",
  greenEarthCategory: "Kategori",
  greenEventTitle: "Green Event",
  greenEventJoin: "Gabung",

  greenEarthVisionTitle: "Visi Kami",
  greenEarthVisionDesc:
    "Menciptakan gerakan aksi lingkungan global yang inklusif, inspiratif, dan berdampak nyata untuk keberlanjutan bumi.",
  greenEarthVision:
    "<span>Lima</span> Misi <span>Strategis</span> Menuju Green Earth",
  vision1: "Aksi Nyata",
  vision1Desc:
    "Mendorong aksi nyata di bidang konservasi, pengurangan sampah, dan efisiensi energi.",
  vision2: "Komunitas",
  vision2Desc:
    "Menghubungkan karyawan, komunitas dan generasi muda dalam satu gerakan.",
  vision3: "Platform Kolaborasi",
  vision3Desc:
    "Menghadirkan platform kolaborasi untuk Green Innovation dan edukasi lingkungan.",
  vision4: "Laporan Keberlanjutan",
  vision4Desc:
    "Menyediakan laporan dampak yang transparan, terukur, dan dapat dievaluasi setiap tahun.",
  vision5: "Budaya Keberlanjutan",
  vision5Desc:
    "Menguatkan budaya keberlanjutan yang menyentuh perilaku sehari-hari.",

  greenEmissionTotal: "Emisi Total",
  greenIntensity: "Intensitas Karbon",
  greenEmissionGraph: "Aktual VS Target",
  greenMonthlyGraph: "Total Emisi Per bulan",
  greenHighestEmission: "Kategori Emisi Tertinggi",
  grennYearlyEmission: "Kategori Emisi Tahunan",
  greenReduction: "Inisiatif Pengurangan Emisi",

  greenActual: "Aktual",
  greenTarget: "Target",
  greenEmission: "Emisi",
  greenEmissionValue: "Nilai Emisi",
  greenTrendLine: "Garis Tren ( MA 3 )",

  greenSustainabilityTitle: "Sustainability Highlight",
  greenNewsTitle: "Berita, Artikel, dan Aktivitas Kami",
  greenActionTitle: "Menciptakan Dampak Nyata bagi Lingkungan",
  greenChallengeTitle: "Mulai dari Tantangan, Wujudkan Perubahan",
  greenInnovationTitle: "Inovasi Keberlanjutan",
  greenHealthTitle: "Komitmen pada Kesehatan dan Kesejahteraan",
  greenTalkTitle: "Berbagi Wawasan, Membangun Masa Depan",

  // greenImpactText: "Green Impact",
  // greenNewsText: "Green News",
  // greenActionText: "Green Action",
  // greenChallengeText: "Green Challenge",
  // greenInnovationText: "Green Innovation",
  // greenHealthText: "Green Health",
  // greenTalkText: "Green Talk",

  greenImpactText: "Green Impact",
  greenNewsText: "Green News",
  greenActionText: "Green Action",
  greenChallengeText: "Green Challenge",
  greenInnovationText: "Green Innovation",
  greenHealthText: "Green Health",
  greenTalkText: "Green Talks",

  // Verify email
  verifyLoading: "Sedang Memeriksa...",
  verifyHello: "Halo",
  verifySubtitle: "Verify your email legit or scam",
  verifyConfirmation: "Email Terverifikasi",
  verifySubConfirmation: "Email yang Anda terima telah dipastikan keasliannya dan dikirim secara resmi oleh PT Salam Pacific Indonesia.",
  verifySender:  "Pengirim",
  verifyRecipient: "Penerima", 
  verifySentOn:  "Waktu Kirim",
  verifySubject: "Subjek",
  verifySecCode: "Kode Sekuritas",
  verifyMakeSure: "Pastikan kode ini sama dengan di email anda.",
  verifyContradict: "Peringatan: Email Tidak Resmi PT SPIL",
  verifyCaution: `<b>PERINGATAN: WASPADA TERHADAP EMAIL MENCURIGAKAN</b>
Hati-hati saat menerima email mencurigakan mengatasnamakan PT SPIL. 

<ul>
<li><b>Jangan men-klik</b> tautan atau lampiran dalam email.</li>
<li><b>Jangan membalas</b> email atau memberikan data pribadi atau data lainnya yang bersifat sensitif.</li>
<li><b>Laporkan segera</b> pada representatif PT SPIL atau lewat saluran komunikasi resmi PT SPIL untuk pemeriksaan.</li>
</ul>
Kewaspadaan anda membantu sistem, data, dan operasi bisnis kami dari potensi serangan penipuan.

Terima kasih atas perhatian dan kerja sama anda.`,  
  verifyInvalid: "Email ini terindikasi bukan berasal dari saluran resmi PT Salam Pacific Indonesia Lines.",
  verifyFailed: "Verifikasi gagal, coba lagi di lain waktu",
  verifyWarningTitle: "Waspada Penipuan\n Mengatasnamakan PT SPIL",
  verifyWarningSubtitle: "Email PT SPIL selalu diakhiri dengan @SPIL.co.id",
  verifyWarningMessage: "Cek QR Code & Link verifikasi pada e-mail untuk verifikasi keaslian e-mail.\n PT SPIL tidak memungut biaya apapun dalam dalam proses rekrutmen. ",
  verifyHotlineRecruitment: "Hotline rekrutment resmi ",
};

export default indonesiaWords;
